import React, { useEffect, useState } from 'react'
import { Select, Input, message, Slider, Tooltip, Radio, InputNumber} from "antd";
import copy from 'copy-to-clipboard'
import axios from "axios";
import { Base64 } from 'js-base64'
import {UnControlled as CodeMirror} from 'react-codemirror2'
import {
  LoadingOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import 'codemirror/lib/codemirror.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/darcula.css'
//代码高亮
import 'codemirror/addon/selection/active-line';
import './Home.scss';
let e = null
const {TextArea} = Input
// 全局接口鉴权的key secret appId
const appId = "08c034b0";
const tyepMap = new Map()
const Home = () => {
  const [scale,setScale] = useState('100%')
  const [show,setShow] = useState(false)
  const [loading,setLoading] = useState(false)
  const [describe,setDescribe] = useState('创建一个函数，求解两数之和')
  const [languageType,setLanguageType] = useState('简体中文')
  const [copyData,setCopyData] = useState('')
  const [attrInfo,setAttrInfo] = useState({
    temperature:11.12,
    top_p:90,
    max_len:33.33,
    sample_num:1,
  })
  const [showAttrInfo,setShowAttrInfo] = useState({
    temperature:0.2,
    top_p:0.95,
    max_len:128,
    sample_num:1,
  })
  //当代码生成数量大于1时用来切换数据的数组
  const [changeSample,setChangeSample] = useState([])
  const [currentSample,setCurrentSample] = useState(0)
  const handleChange = (value) => {
    setLanguageType(value)
    setShow(false)
  }
  const handleGengerateCode = () => {
    if(!describe.trim())return
    handleRequest()
  } 
  //请求结果
  const handleRequest = async(key) => {
    setLoading(true)
    setCopyData('')
    const keyData = key || describe
    const temperature = showAttrInfo.temperature
    const top_p = showAttrInfo.top_p
    const max_len = showAttrInfo.max_len
    const sample_num = showAttrInfo.sample_num
    const data = {
      "header": {
          "app_id": appId,
          "uid": "39769795890",
          "did": "SR082321940000200",
          "imei": "8664020318693660",
          "imsi": "4600264952729100",
          "mac": "6c:92:bf:65:c6:14",
          "net_type": "wifi",
          "net_isp": "CMCC",
          "status": 3,
          "request_id": null,
          "res_id": ""
      },
      "parameter": {
          "mCodeGen": {
            "src_lan": tyepMap.get(languageType),
            "sample_num": sample_num,
            "temperature": temperature,
            "top_p": top_p,
            "max_len": max_len,
              "res_code": {
                  "encoding": "utf8",
                  "compress": "raw",
                  "format": "json"
              }
          }
      },
      "payload": {
          "raw_text": {
              "encoding": "utf8",
              "compress": "raw",
              "format": "plain",
              "status": 3,
              "text": Base64.encode(keyData)
          }
      }
    }
    const url = `/api/v1/common-service/http/common?forwardUrl=https://cn-east-1.api.xf-yun.com/v1/private/s7ab78fab&appId=08c034b0&source=aiPaas`;
    const res = await axios.post(url,data)
    const text = res.data.payload.res_code.text
    let textDecode = Base64.decode(text)
    const res_code = JSON.parse(textDecode).res_code
    textDecode = handleData(res_code[0])
  
    if(sample_num > 1){
      setChangeSample([...res_code])
    }else{
      setChangeSample([])
    }
    setCurrentSample(0)
    setCopyData(textDecode)
    setLoading(false)
  }
  const handleData = (value) => {
    let arr = value.split('\n')
    let tempArr = []
    arr.map(i => {
      if(i.length < 70){
        tempArr.push(i)
      }else {
        for(let item = 0;item < i.length;item+=70){
          tempArr.push(i.slice(item,item+70))
        }
      }
    })
    return tempArr.join('\n')
  }   
  const setFontSize = () => {
    let ww = document.documentElement.clientWidth
    setScale(ww / 1440 * 100 + '%')
    const sliders = document.getElementsByClassName('attr-slider')
    for(let i = 0; i < sliders.length; i++){
      sliders[i].style.zoom = 1440 / ww * 100 + '%'
      sliders[i].style.width = ww / 1440 * 317 + 'px' 
    }
  }
  const handleCopy = () => {
    copy(e.getValue())
    message.success('复制成功')
  }
  const handleAttrChange = (value,attr) => {
    const showAttrInfoObj = {...showAttrInfo}
    const attrInfoObj = {...attrInfo}
    let finallyValue = ''
    if(attr === 'temperature'){
      finallyValue = Math.floor((0.1 + value * 0.9/100) * 100)/100
    }else if(attr === 'top_p'){
      finallyValue = Math.floor((0.5 + value / 200) * 100)/100
    }else if(attr === 'max_len'){
      finallyValue = Math.round(64 + value * 192/100)
    }else if(attr === 'sample_num'){
      finallyValue = value
    }
    showAttrInfoObj[attr] = finallyValue
    attrInfoObj[attr] = value
    setShowAttrInfo({...showAttrInfoObj})
    setAttrInfo({...attrInfoObj})
  }
  const handleSampleChange = (value) => {
    const str = changeSample[value].trim()
    setCopyData(str)
    setCurrentSample(value)
  }
  //input框值变化的监听
  const handleInputChange = (value,attr) => {
    let finallyValue = parseFloat(value)
    const attrInfoObj = {...attrInfo}
    let percentValue = 0
    const showAttrInfoObj = {...showAttrInfo}
    if(attr === 'temperature'){
      percentValue = ((finallyValue - 0.1) * 100) / 0.9
    }else if(attr === 'top_p'){
      percentValue = (finallyValue - 0.5) * 200
    }else if(attr === 'max_len'){
      finallyValue = Math.round(finallyValue)
      percentValue = ((finallyValue - 64) * 100 ) / 192
    }
    showAttrInfoObj[attr] = finallyValue
    attrInfoObj[attr] = percentValue
    setAttrInfo({...attrInfoObj})
    setShowAttrInfo({...showAttrInfoObj})
  }

  useEffect(() => {
    let descript = `'''Create a function to solve the sum of two numbers '''
    def sum_two_numbers(n1, n2):
        '''
        :param n1: first number
        :param n2: second number
        :return: sum of two numbers
        '''
        return n1 + n2`
    setCopyData(descript)
    tyepMap.set('简体中文','cn')
    tyepMap.set('英语','en')
    setFontSize()
    window.onresize = setFontSize
  },[])
  return (
    <div className='home' style={{zoom:scale}}>
      <div className='title'>
      </div>
      <div className='content'>
        <div className='left'>
            <div className='left-title'>

            </div>
            <div className='left-text'></div>
            <div className='language-select'>
              <div className='selected-option' onClick={() => setShow(true)}>
                <span>{languageType}</span>
                <span></span>
              </div>
              {show && <div defaultValue="简体中文" className='selected-open-ex'  onMouseLeave={() => setShow(false)}>
                <div  onClick ={() => handleChange('简体中文')}>简体中文</div>
                <div onClick ={() => handleChange('英语')}>英语</div>
              </div>}
            </div>
            <div className='simple-describe'>
              <TextArea placeholder='简单描述需开发的功能语句' value = {describe} onChange={(e) => setDescribe(e.target.value)}></TextArea>
            </div>
            <div className='attr-container'>
                <div className='attr'>
                  <Tooltip  title='控制生成代码时候的温度，温度越高，生成结果的多样性越高' getPopupContainer = {() => document.getElementsByClassName('attr-container')[0]}>
                  <span> <span style={{marginRight:2}}>
                  temperature</span><ExclamationCircleOutlined style={{color:'gray'}} /></span>
                  </Tooltip>
                  <InputNumber  min="0.1"
                  style={{height:30,width:70}}
                  max="1"
                  step="0.01"
                stringMode value={showAttrInfo.temperature} onChange = {(value) => handleInputChange(value,'temperature')}></InputNumber>
                </div>
                <div>
                  <Slider tooltip = {{open:false}}  disabled={false}  value={attrInfo.temperature}  onChange={(value) => handleAttrChange(value,'temperature')} className='attr-slider' />
                </div>
              </div>
              <div className='attr-container'>
                <div className='attr'>
                  <Tooltip title='top-p采样算法中的累计概率门限' getPopupContainer = {() => document.getElementsByClassName('attr-container')[1]}>
                  <span> <span style={{marginRight:2}}>
                  top_p</span><ExclamationCircleOutlined style={{color:'gray'}} /></span>
                  </Tooltip>
                {/* <span>{showAttrInfo.top_p}</span> */}
                <InputNumber  
                style={{height:30,width:70}}
                min="0.5"
                  max="1"
                  step="0.01"
                stringMode value={showAttrInfo.top_p} onChange = {(value) => handleInputChange(value,'top_p')}></InputNumber>
                </div>
                <div>
                  <Slider tooltip = {{open:false}} disabled={false}  value={attrInfo.top_p}  onChange={(value) => handleAttrChange(value,'top_p')} className='attr-slider'  />
                </div>
              </div>
              <div className='attr-container'>
                <div className='attr'>
               <Tooltip title='生成代码的最大长度' getPopupContainer = {() => document.getElementsByClassName('attr-container')[2]}>
               <span> <span style={{marginRight:2}}>
               max_len</span><ExclamationCircleOutlined style={{color:'gray'}} /></span>
               </Tooltip>
               <InputNumber 
               style={{height:30,width:70}}
               min="64"
                  max="256"
                  step="1"
                stringMode value={showAttrInfo.max_len} onChange = {(value) => handleInputChange(value,'max_len')}></InputNumber>
                </div>
                <div>
                  <Slider tooltip = {{open:false}}  disabled={false}  value={attrInfo.max_len}  onChange={(value) => handleAttrChange(value,'max_len')} className='attr-slider' />
                </div>
              </div>
              <div className='attr-container'>
                <div className='attr'>
               <Tooltip title='生成代码的数量' getPopupContainer = {() => document.getElementsByClassName('attr-container')[3]}>
               <span> <span style={{marginRight:2}}>
               sample_num</span><ExclamationCircleOutlined style={{color:'gray'}} /></span>
               </Tooltip>
                {/* <span>{attrInfo.sample_num}</span> */}
                </div>
                    <Radio.Group onChange={(e) => handleAttrChange(e.target.value,'sample_num')} value={attrInfo.sample_num} style={{margin:'8px 0 0 4px'}}>
                    <Radio value={1}>1</Radio>
                    <Radio value={2} style={{marginLeft:40}}>2</Radio>
                    <Radio value={3} style={{marginLeft:40}}>3</Radio>
                  </Radio.Group>
              </div>
            <div className='gengerate-code' onClick={() => handleGengerateCode()}>生成代码</div>
        </div>
        <div className='right'>
          <div className='code_header'>
            <div className='left-code'>
              代码如下：
            </div>
            <div className='right-code' onClick={() => handleCopy()}>
            </div>
          </div>
          <div className='code_content'>
          <div className='change-sample'>
          {!loading && changeSample.map((i,index) => <span key={index} className='sample-container' onClick={() => handleSampleChange(index)}>
            <span></span>
            <span style={{color:currentSample === index?'#fff':'rgb(134, 137, 154)'}}>代码片段{index+1}</span>
            {currentSample === index && <span></span>}
          </span>)}
          </div>
           {loading &&  <LoadingOutlined className='loading'  />}
          <div style={{paddingTop:!loading && changeSample.length > 1?'18px':''}}>
          <CodeMirror
            options = {{
              value:copyData,
              theme:'darcula',
              lineNumbers: true, //显示行号
              mode: 'text/x-python',
              styleActiveLine: true,
              line: true,
            }}
            contenteditable=''
            editorDidMount={editor => { e = editor }}
          ></CodeMirror>
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Home
